// extracted by mini-css-extract-plugin
export default {"rating":"ey-z","numberOfStars":"fy-z","count":"gy-z","barGraphSpacing":"hy-z","barGraph":"iy-z"};